module.exports = __webpack_public_path__ + "img/img-21.4aa9e85e.webp";